import { TQueryParams } from './query-params.models';

/**
 * Action that is dispatched when the query params change. This action can be implemented in many states so that
 * the query param values are stored where they are most relevant.
 */
export class QueryParamsChanged {
    static readonly type = '[Router] Query Params Changed';
    constructor(public queryParams: TQueryParams) {}
}

/**
 * Action that can be dispatched to update the query params
 */
export class UpdateQueryParams {
    static readonly type = '[Router] UpdateQueryParams';
    constructor(public queryParams: TQueryParams) {}
}
